<template>
  <scroll-bar id="wrap-scroll-bar">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      :unique-opened="true"
      background-color="#5970A3"
      text-color="#fff"
      active-text-color="#fff"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import ScrollBar from "@/components/ScrollBar";

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters(["sidebar", "routers", "userInfo"]),
    routes() {
      if (
        this.userInfo &&
        ["seller", "agent", "agent_assistant", "customer"].indexOf(
          this.userInfo.userType
        ) !== -1
      ) {
        // 根据身份，对菜单做特殊处理
        return this.setSpecialRouter(this.routers);
      } else {
        return this.routers;
      }
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  methods: {
    setSpecialRouter(routers) {
      if (routers) {
        let _this = this;
        routers.forEach(function (part, index, routersArray) {
          // 判断码商的代理或卡主直接不显示整个提现、佣金父菜单
          if (
            ["customer", "agent"].indexOf(_this.userInfo.userType) !== -1 &&
            _this.userInfo.commonUserType === 3 &&
            part.meta &&
            ["withdraw", "commission"].indexOf(part.name) !== -1
          ) {
            // 提现、佣金
            routersArray[index].hidden = true;
          }

          if (part.children && part.meta) {
            if (part.meta.title === "数据") {
              /* 
                在代理的情况
                如果是非通道型代理，则隐藏 通道型代理数据 菜单 
              */
              part.children.forEach(function (p, i) {
                if (
                  p.path === "statisticsCommonAgent" &&
                  _this.userInfo.commonUserType === 0
                ) {
                  routersArray[index].children[i].hidden = true;

                  /*
                    如果只有一个子菜单，子菜单会被当做第一层，将不会被正确隐藏
                    因此多逻辑，如果本菜单内仅有一个上面已经隐藏的子菜单，则隐藏上层
                  */
                  if (routersArray[index].children.length === 1) {
                    routersArray[index].hidden = true;
                  }
                }
              });
            } else if (part.meta.title === "用户") {
              /* 
                在代理的情况
                如果无手动权限，则隐藏 手动卡主, 手动app卡主 菜单 
              */
              part.children.forEach(function (p, i) {
                if (
                  (p.path === "userManualCustomer" ||
                    p.path === "userManualAppCustomer") &&
                  !_this.userInfo.haveManualPermission
                ) {
                  routersArray[index].children[i].hidden = true;

                  if (routersArray[index].children.length === 1) {
                    routersArray[index].hidden = true;
                  }
                }
                // haveManageManualPermission 是否有管理手动卡主的权限，若有此权限 代理的菜单可以拥有客服管理员菜单
                if (
                  p.path === "userKefuAdmin" &&
                  !_this.userInfo.haveManageManualPermission
                ) {
                  routersArray[index].children[i].hidden = true;

                  if (routersArray[index].children.length === 1) {
                    routersArray[index].hidden = true;
                  }
                }
              });
            } else if (part.meta.title === "订单") {
              /*
                在商户的情况
                收款订单 改为 支付订单
                付款订单 改为 提现订单
              */
              part.children.forEach(function (p, i) {
                switch (p.meta && p.meta.title) {
                  case "收款订单":
                    routersArray[index].children[i].meta.title = "支付订单";
                    break;
                  case "付款订单":
                    routersArray[index].children[i].meta.title = "提现订单";
                    break;
                }

                // 在卡主, 代理的情况
                if (
                  ["customer", "agent"].indexOf(_this.userInfo.userType) !== -1
                ) {
                  // 若为 "一般型"，隐藏 "二维码订单" 菜单
                  if (
                    p.path === "orderCode" &&
                    _this.userInfo.commonUserType === 0
                  ) {
                    routersArray[index].children[i].hidden = true;
                  }

                  // 若为 "码商"
                  if (
                    [
                      "orderPay", // 支付订单
                      "orderWithdraw", // 提现订单
                      "withdrawOrderReceiptOperate", // 提现回单操作
                      "orderReceiptCheck", // 出款审核
                    ].indexOf(p.path) !== -1 &&
                    _this.userInfo.commonUserType === 3
                  ) {
                    routersArray[index].children[i].hidden = true;
                  }
                }
              });
            } else if (part.meta.title === "银行") {
              part.children.forEach(function (p, i) {
                // 在卡主, 代理的情况
                if (
                  ["customer", "agent"].indexOf(_this.userInfo.userType) !== -1
                ) {
                  // 若为 "一般型"，隐藏 "二维码" 菜单
                  if (
                    p.path === "accountCode" &&
                    _this.userInfo.commonUserType === 0
                  ) {
                    routersArray[index].children[i].hidden = true;
                  }

                  // 若为 "码商"
                  if (
                    [
                      "bank", // 银行卡
                    ].indexOf(p.path) !== -1 &&
                    _this.userInfo.commonUserType === 3
                  ) {
                    routersArray[index].children[i].hidden = true;
                  }
                }
              });
            }
          }
        });
      }

      return routers;
    },
  },
};
</script>
<style scoped>
#wrap-scroll-bar /deep/ .el-menu-item.is-active {
  text-shadow: 0px 0px 22px #fff !important;
}
#app .sidebar-container:hover .el-submenu__title {
  color: red !important;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue